<template>
  <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>
      <!-- <Spinner ref="spinner"></Spinner> -->
      <div class="mb-4">
        <zigZag></zigZag>
      </div>
      <v-layout text-xs-center mt-5>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-start row mx-3 mt-0 align-center>
            <v-flex>
              <v-layout row>
                <v-icon class="mr-2">fa-plus-circle</v-icon>
                <div
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >{{formType=='new'?"Create New":"Edit"}} Business Rule - {{businessRule.RuleKey}} - {{businessRule.Description}}</div>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex>
                  <v-layout class="buttons mb-0 mr-0" justify-end row>
                    <v-btn icon @click="cancel" class="pa-0 mr-0">
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-flex mb-3 xs12 mx-2>
            <v-form v-model="valid" @submit="editBusinessRule" ref="editBusinessForm">
              <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                <v-layout hide-details justify-start row mt-0 mb-0>
                  <!-- <v-flex hide-details mx-4 xs3>
                    <v-autocomplete
                      :items="ddlCategory"
                      v-model="report.CategoryId"
                      item-text="Text"
                      item-value="Value"
                      label="Category*"
                      required
                      :rules="requiredRules"
                      tabindex="0"
                    ></v-autocomplete>
                  </v-flex>-->

                  <v-flex mx-4 xs4>
                    <v-text-field
                      v-model="businessRule.Description"
                      label="Description*"
                      :rules="requiredRules"
                      tabindex="1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex mx-4 xs7>
                    <v-text-field
                      v-if="isText"
                      v-model="businessRule.Value"
                      label="Value*"
                      :rules="valueRules"
                      tabindex="2"
                    ></v-text-field>
                    <v-autocomplete
                    v-if="!isText"
                      :items="ddlReturn"
                      v-model="businessRule.Value"
                      item-text="Text"
                      item-value="Value"
                      label="Value*"
                      required
                      :rules="requiredRules"
                      tabindex="0"
                    ></v-autocomplete>
                    <!-- <v-text-field
                    v-if="businessRule.ValueType == 'str'"
                      v-model="businessRule.Value"
                      label="Value*"
                      :rules="requiredRules"
                      tabindex="2"
                    ></v-text-field>-->
                  </v-flex>
                  <!-- <v-flex hide-details mx-4 xs2>
                    <v-autocomplete
                      :items="ddlStatus"
                      v-model="report.IsEnabled"
                      item-text="Text"
                      item-value="Value"
                      label="Status*"
                      required
                      :rules="requiredRules"
                      tabindex="1"
                    >
                    <template slot="selection" slot-scope="data">
                      <v-layout row>
                        <v-flex
                          :class="{'green--text': data.item.Value === 'true', 'red--text': data.item.Value === 'false'}"
                        >{{ data.item.Text }}</v-flex>
                      </v-layout>
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-layout row>
                        <v-flex
                        :class="{'green--text': data.item.Value === 'true', 'red--text': data.item.Value === 'false'}"
                        >{{ data.item.Text }}</v-flex>
                      </v-layout>
                    </template>
                    </v-autocomplete>
                  </v-flex>-->

                  <v-flex mx-4 xs1>
                    <v-btn
                      color="success"
                      @click="editBusinessRule"
                      class="ml-2 mr-4"
                      v-if="formType=='edit'"
                      tabindex="4"
                    >Update Rule</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-form>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import axios from "axios";
import Bus from "../../bus";
import moment from "moment";
import zigZag from "../../components/ZigZag";

export default {
  name: "EditBusinessRulesManagement",

  components: {
    Spinner,
    zigZag
  },

  data: () => ({
    dialog: false,
    valid: true,

    formType: null,

    resolve: null,
    reject: null,
    businessRule: {},
    ddlTrueFalse: [{Text:"YES", Value:"TRUE"}, {Text:"NO", Value:"FALSE"}],
    ddlYesNo: [{Text:"YES", Value:"YES"}, {Text:"NO", Value:"NO"}],


    requiredRules: [v => !!v || "Required"]
  }),
  computed: {
    currentDate() {
      return moment()
        .format("YYYY-MM-DD")
        .toString();
    },
    isText() {
      var valueType = this.businessRule.ValueType;
      return valueType == "str" ||
        valueType == "fp" ||
        valueType == "int" ||
        valueType == "dec" ||
        valueType == "file" ||
        valueType == "email"
        ? true
        : false;
    },
    ddlReturn(){
      var valueType = this.businessRule.ValueType;
      var ddlReturn;
      switch (valueType) {
        case "bool":
          ddlReturn = this.ddlTrueFalse
          break;
        case "yn":
         ddlReturn= this.ddlYesNo
          break;
          default:
            ddlReturn=this.ddlTrueFalse
            break;
      }
      return ddlReturn

    },
    valueRules() {
      var valueType = this.businessRule.ValueType;
      var rules;
      switch (valueType) {
        case "str":
          rules = [v => !!v || "Required"];
          break;
        case "int":
          rules = [
            v => new RegExp("^\\d+$").test(v) || "Must be a number",
            v => !!v || "Required"
          ];
          break;
        case "dec":
          rules = [
            v =>
              new RegExp("^\\d+(?:\\.\\d{0,2})?$").test(v) ||
              "Must be in decimal format",
            v => !!v || "Required"
          ];
          break;
        case "email":
          rules = [
            v => !!v || "Required",
            v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-mail must be valid"
          ];
          break;
        case "file":
          rules = [
            v => !!v || "Required",
            v =>
              new RegExp("^[a-zA-Z]:\\.*|^\\\\.*").test(v) ||
              "Must be a vaild file path and file"
          ];
          break;
          case "fp":
          rules = [
            v => !!v || "Required",
            v =>
              new RegExp("^[a-zA-Z]:\\.*|^\\\\.*").test(v) ||
              "Must be a vaild file path and file"
          ];
          break;
        default:
          rules = [v => !!v || "Required"];
          break;
      }

      return rules;
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },

    // Get data for elements in component from response data props
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for props of elements
    async getPropData(url, obj, prop) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`][`${prop}`] = resp.data))
        .catch(err => console.log(err));
    },

    // Get data for elements in component from response data
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },
    async open(item) {
      // this.report = await Object.assign({}, item);
      // this.formType = "new";
      // this.dialog = true;
      // this.getDropDownLists();
    },
    async openEdit(item) {
      this.dialog = await true;
      this.businessRule = await Object.assign({}, item);
      if (this.businessRule.ValueType == "bool" || this.businessRule.ValueType == "yn"){
        var value = this.businessRule.Value.toUpperCase()
        this.businessRule.Value = value
      }
      // this.report.IsEnabled = this.report.IsEnabled.toString()
      this.formType = "edit";
      // this.getDropDownLists();

      this.$emit("parentScroll");
    },
    async getDropDownLists() {
      axios.get("/api/Report/GetAdminEditReportDDLs").then(res => {
        this.ddlCategory = res.data.ddlCategory;
        this.ddlStatus = res.data.ddlStatus;
      });
    },

    // async createBatchRecord() {
    //   if (this.$refs.createBatchRecordForm.validate()) {
    //     var batchId = this.report.batchId;
    //     var typeId = this.report.typeId;
    //     var type = this.report.type;
    //     var date = this.report.date;
    //     this.report.docTypeId = typeId
    //     var result = await axios
    //       .post("api/Receivables/CreateBatchRecord", this.report)
    //       .then(res => {
    //         this.report = { batchId: batchId, typeId: typeId, type: type, date:date };
    //         Bus.$emit("alert", {
    //           color: "success",
    //           message: "New Batch report Created Successfully"
    //         });
    //         this.$root.$emit("initialize", this.initialize);
    //         this.$emit("parentRefresh");
    //       });
    //   }
    // },
    async editBusinessRule() {
      if (this.$refs.editBusinessForm.validate()) {
        var result = await axios
          .put("api/BusinessRules/UpdateRule", this.businessRule)
          .then(res => {
            Bus.$emit("alert", {
              color: "success",
              message: "Business Rule Updated Successfully"
            });
            this.close();
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    cancel() {
      (this.businessRule = {}), (this.dialog = false);
      // this.resolve(false)
      // this.resetFormFilters()
      this.$emit("parentInitSelectedRow");
    },
    close() {
      (this.businessRule = {}), (this.dialog = false);
      // this.resolve(item)
      // this.$root.$emit("initialize", this.initialize);
      this.$emit("parentRefresh");
      this.$emit("parentInitSelectedRow");
    },
    isOpen() {
      return this.dialog;
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  }
};
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

